import React from 'react';
import styled from 'styled-components';

const StyledCard = styled.div`
  background: #fff;
  border-radius: 3px;
  height: ${props => props.height || "100%"};
  margin: ${props => props.margin || 0};
  transition: all .25s ease;
  overflow: hidden;
`;

const Card = (props) => {
  return <StyledCard {...props}>{props.children}</StyledCard>
};

export default Card;
